<app-dashboard-stats-card [title]="'Available To Request'" subtitle="Packages that are available to request by your provider." [count]="getPackageCount()"
                          [routerLink]="'/potential-packages'" />
